import { Step } from "../../../stepper/stepper.component";

export interface Help {
    casilla: string;
    texto: string;    
}

export enum DirectionType {
    next = 'next',
    previous = 'previous'
}

export abstract class HandlerModal {

    protected indexStepper: number = 0;
    protected stepsList: Step[] = [];
    protected helpText: string = '';

    private lisHelp: Help[] = [];

    constructor(steps: Step[], listHelp: Help[]) {
        this.stepsList = steps;
        this.lisHelp = listHelp;
        this.showHelp(this.indexStepper);
    }

    protected abstract controlStep(direction: DirectionType): void;

    protected nextStep(): void {
        if (this.indexStepper === (this.stepsList.length - 1)) return;
        this.updateSteps(this.indexStepper + 1);
        this.controlStep(DirectionType.next);
    }

    protected previousStep(): void {
        if (this.indexStepper === 0) return;
        this.updateSteps(this.indexStepper - 1);
        this.controlStep(DirectionType.previous);
    }

    protected changeStep(index: number): void {
        this.updateSteps(index);
    }

    private updateSteps(index: number) {
        this.stepsList.forEach((item, i) => {
            item.active = i == index;
            item.completed = i > index || i == index ? false : true;
        });
        this.indexStepper = index;
        this.showHelp(this.indexStepper);
    }

    private showHelp(index: number): void {
        const model: Step = this.stepsList[index];
        const helps: string[] = model['listHelp'].map(item => {
            const help = this.lisHelp.find((subItem) => subItem.casilla.toString() === item);
            //return help ? help.texto==''? 'Este espacio está dispuesto para mostrar información de las preguntas que tienen ayuda.':help.texto :'Este espacio está dispuesto para mostrar información de las preguntas que tienen ayuda.';
            return help ? help.texto==''? '':help.texto :'';
        });
        this.helpText = helps.join('<br>');
    }    

}


// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/formulario-no-experto/secciones/modales/handler-modals.ts